/* GLOWRY Theme — master JS */
(function () {
  // Reveal on scroll
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach(function (el) { obs.observe(el); });
  } else if (reveals.length) {
    reveals.forEach(function (el) { el.classList.add('visible'); });
  }

  // Header scroll state
  var nav = document.querySelector('[data-nav]');
  if (nav) {
    var onScroll = function () {
      if (window.scrollY > 60) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile menu toggle
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && menu) {
    menuToggle.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  // Product page: variant picker + add to cart
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantInput = productForm.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare]');
    var addBtn = productForm.querySelector('[data-add-btn]');
    var optionInputs = productForm.querySelectorAll('[data-option-input]');
    var variantsData = window.glowryVariants || [];

    function getSelectedOptions() {
      var selected = [];
      var groups = {};
      optionInputs.forEach(function (input) {
        if (input.type === 'radio' && input.checked) {
          groups[input.name] = input.value;
        } else if (input.tagName === 'SELECT') {
          groups[input.name] = input.value;
        }
      });
      for (var key in groups) selected.push(groups[key]);
      return selected;
    }

    function updateVariant() {
      var selected = getSelectedOptions();
      var matched = variantsData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      if (!matched) {
        variantInput.value = '';
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
        }
        return;
      }
      variantInput.value = matched.id;
      if (priceEl) priceEl.textContent = matched.price_formatted;
      if (compareEl) {
        if (matched.compare_at_price && matched.compare_at_price > matched.price) {
          compareEl.textContent = matched.compare_at_price_formatted;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (matched.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.dataset.text || 'Add to Cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold Out';
        }
      }
      var url = new URL(window.location);
      url.searchParams.set('variant', matched.id);
      window.history.replaceState({}, '', url);
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    // Quantity
    var qtyInput = productForm.querySelector('[data-qty]');
    var qtyMinus = productForm.querySelector('[data-qty-minus]');
    var qtyPlus = productForm.querySelector('[data-qty-plus]');
    if (qtyMinus && qtyInput) qtyMinus.addEventListener('click', function () {
      var v = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      qtyInput.value = v;
    });
    if (qtyPlus && qtyInput) qtyPlus.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });

    // Image gallery
    var thumbs = document.querySelectorAll('[data-thumb]');
    var mainImg = document.querySelector('[data-main-image]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        if (mainImg) mainImg.src = t.dataset.thumb;
      });
    });
  }

  // Cart line quantity update
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-cart-qty]')) cartForm.submit();
    });
  }

  // Search overlay
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchClose = document.querySelector('[data-search-close]');
  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function () {
      searchOverlay.classList.add('open');
      var input = searchOverlay.querySelector('input');
      setTimeout(function () { if (input) input.focus(); }, 100);
    });
  }
  if (searchClose && searchOverlay) {
    searchClose.addEventListener('click', function () {
      searchOverlay.classList.remove('open');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('open')) {
      searchOverlay.classList.remove('open');
    }
  });
})();
